<template>

  <div class="hero-carousel__slide hero-carousel__slide--centered" v-if="isCenteredImage(slide.SlideType)">
    <div v-if="isVideo(slide.MediaType)" class="hero-carousel__image">
      <video autoplay=1 muted=1 loop=1>
        <source :src="slide.VideoUrl" type="video/mp4" />
      </video>
      <div class="hero-carousel__content" :style="{color: getTextColor(slide.BackgroundColor)}">
        <h1 class="hero-carousel__title">{{slide.Header}}</h1>
        <p class="hero-carousel__paragraph">{{slide.Paragraph}}</p>
        <a v-if="slide.ButtonUrl != '' && slide.ButtonLabel != ''" :href="slide.ButtonUrl" class="btn btn-outline-secondary hero-carousel__button">{{slide.ButtonLabel}}</a>
      </div>
    </div>
    <div v-else class="hero-carousel__image" :style="{backgroundImage:`url(${slide.ImageUrl})`}">
      <div class="hero-carousel__content" :style="{color: getTextColor(slide.BackgroundColor)}">
        <h1 class="hero-carousel__title">{{slide.Header}}</h1>
        <p class="hero-carousel__paragraph">{{slide.Paragraph}}</p>
        <a v-if="slide.ButtonUrl != '' && slide.ButtonLabel != ''" :href="slide.ButtonUrl" class="btn btn-outline-secondary hero-carousel__button">{{slide.ButtonLabel}}</a>
      </div>
    </div>
  </div>

  <div class="hero-carousel__slide hero-carousel__slide--image-left" v-if="isImageLeft(slide.SlideType)">
    <div v-if="isVideo(slide.MediaType)" class="hero-carousel__image">
      <video autoplay=1 muted=1 loop=1>
        <source :src="slide.VideoUrl" type="video/mp4" />
      </video>
    </div>
    <img v-else class="hero-carousel__image" :src="slide.ImageUrl" />
    <div class="hero-carousel__content" :style="{color: getTextColor(slide.BackgroundColor),backgroundColor: slide.BackgroundColor}">
      <h1 class="hero-carousel__title">{{slide.Header}}</h1>
      <p class="hero-carousel__paragraph">{{slide.Paragraph}}</p>
      <a v-if="slide.ButtonUrl != '' && slide.ButtonLabel != ''" :href="slide.ButtonUrl" class="btn btn-outline-secondary hero-carousel__button">{{slide.ButtonLabel}}</a>
    </div>
  </div>

  <div class="hero-carousel__slide hero-carousel__slide--image-right" v-if="isImageRight(slide.SlideType)">
    <div class="hero-carousel__content" :style="{color: getTextColor(slide.BackgroundColor),backgroundColor: slide.BackgroundColor}">
      <h1 class="hero-carousel__title">{{slide.Header}}</h1>
      <p class="hero-carousel__paragraph">{{slide.Paragraph}}</p>
      <a v-if="slide.ButtonUrl != '' && slide.ButtonLabel != ''" :href="slide.ButtonUrl" class="btn btn-outline-secondary hero-carousel__button">{{slide.ButtonLabel}}</a>
    </div>
    <div v-if="isVideo(slide.MediaType)" class="hero-carousel__image">
      <video autoplay=1 muted=1 loop=1>
        <source :src="slide.VideoUrl" type="video/mp4" />
      </video>
    </div>
    <img v-else class="hero-carousel__image" :src="slide.ImageUrl" />
  </div>

</template>
<script lang="ts">
  import { IHeroCarouselSlideProps, SlydeTypeOption, MediaTypeOption, Colors } from "../helpers/HeroCarouselTypes";

  export default {
    name: 'HeroCarouselSlide',
    props: {
      slide: {
        type: Object,
        required: true,
      },
    },
    setup(props: IHeroCarouselSlideProps) {
      const isCenteredImage = (opt: Number) => {
        return (opt as SlydeTypeOption) == SlydeTypeOption.CenteredImageBackground
      }

      const isImageLeft = (opt: Number) => {
        return (opt as SlydeTypeOption) == SlydeTypeOption.SplitImageLeft
      }

      const isImageRight = (opt: Number) => {
        return (opt as SlydeTypeOption) == SlydeTypeOption.SplitImageRight
      }

      const isVideo = (opt: Number) => {
        return (opt as MediaTypeOption) == MediaTypeOption.Video
      }

      const getTextColor = (opt: Colors): string => {
        if (
          opt == Colors.White ||
          opt == Colors.Lime ||
          opt == Colors.LightBlue ||
          opt == Colors.LightTeal ||
          opt == Colors.LightOrange
        ) {
          return "#172C36"
        } else {
          return "#FFFFFF"
        }
      }

      return {
        isCenteredImage,
        isImageLeft,
        isImageRight,
        getTextColor,
        isVideo
      }
    }
  };
</script>
